function isPlainObject(value: unknown): value is Record<string, unknown> {
    return !!value && typeof value === 'object' && !Array.isArray(value);
}

/**
 * Same values, whatever order the model wrote its keys and nested objects in — comparing
 * JSON.stringify output directly would call a re-ordered repeat of the same fields a change.
 */
function stableForm(value: unknown): unknown {
    if(Array.isArray(value)) {
        return value.map(stableForm);
    }
    if(!isPlainObject(value)) {
        return value;
    }
    return Object.keys(value)
        .sort()
        .reduce<Record<string, unknown>>((out, key) => {
            out[key] = stableForm(value[key]);
            return out;
        }, {});
}

export function sameFieldValues(
    a: Record<string, unknown> | null | undefined,
    b: Record<string, unknown> | null | undefined,
): boolean {
    return JSON.stringify(stableForm(a ?? {})) === JSON.stringify(stableForm(b ?? {}));
}
